import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Auth } from 'aws-amplify'

const chroniclesApi = createApi({
  reducerPath: 'chronicles',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://hm9c6wog8e.execute-api.sa-east-1.amazonaws.com/prod/',
    prepareHeaders: async (headers) => {
      const session = await Auth.currentSession()
      const token = session.getIdToken().getJwtToken()
      if (token) headers.set('Authorization', token)
    },
  }),
  endpoints(build) {
    return {
      fetchChronicles: build.query({
        query: (user_id: string) => {
          return {
            url: '/chronicles',
            params: {
              user_id,
            },
            method: 'GET',
          }
        },
      }),
      fetchChronicle: build.query({
        query: (chronicle_id?: string) => {
          return {
            url: `/chronicles/${chronicle_id}`,
            method: 'GET',
          }
        },
        keepUnusedDataFor: 30,
      }),
      createChronicle: build.mutation({
        query: (chronicle: any) => {
          return {
            url: `/chronicles`,
            method: 'POST',
            body: chronicle,
          }
        },
      }),
      deleteChronicle: build.mutation({
        query: (chronicle_id: string) => {
          return {
            url: `/chronicles/${chronicle_id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export { chroniclesApi }
export const {
  useFetchChroniclesQuery,
  useFetchChronicleQuery,
  useCreateChronicleMutation,
  useDeleteChronicleMutation,
} = chroniclesApi
